// ARQUIVO ATUALIZADO E CORRIGIDO
import 'cross-fetch/polyfill';

const API_KEY = 'AIzaSyAyK8LghL5yR6cJCVJDAsQH-Cx0fQfJ6vg';
// --- INÍCIO DA ALTERAÇÃO 1: Padronizando a URL da API ---
const API_URL = 'https://generativelanguage.googleapis.com/v1beta/models/gemini-2.5-flash-preview-05-20:generateContent';
// --- FIM DA ALTERAÇÃO 1 ---

export const callGeminiForHourEstimation = async (taskDescription) => {
    // --- INÍCIO DA ALTERAÇÃO 2: Prompt mais robusto ---
    const prompt = `Você é um especialista em estimar tempo para tarefas de design.
Sua única função é retornar o número de horas para a tarefa abaixo.
Responda APENAS com o número. Sem texto, sem explicações.

Tarefa: "${taskDescription}"
Horas:`;
    // --- FIM DA ALTERAÇÃO 2 ---

    const payload = { contents: [{ parts: [{ text: prompt }] }] };
    const url = `${API_URL}?key=${API_KEY}`;
    
    try {
        const response = await fetch(url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload)
        });
        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
        
        const result = await response.json();
        const textResult = result.candidates?.[0]?.content?.parts?.[0]?.text;
        
        const hours = textResult ? parseInt(textResult.match(/\d+/)?.[0] || '0', 10) : 0;
        return hours > 0 ? hours : 1; // Retorna no mínimo 1 hora se encontrar algo
    } catch (error) {
        console.error("Erro ao estimar horas com IA:", error);
        return 0;
    }
};

export const callGeminiAPI = async (prompt) => {
    const payload = { contents: [{ role: "user", parts: [{ text: prompt }] }] };
    // --- INÍCIO DA ALTERAÇÃO 3: Usando a URL padronizada ---
    const url = `${API_URL}?key=${API_KEY}`;
    // --- FIM DA ALTERAÇÃO 3 ---
    try {
        const response = await fetch(url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload)
        });
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        const result = await response.json();
        return result.candidates?.[0]?.content?.parts?.[0]?.text || null;
    } catch (error) {
        console.error("Erro ao chamar a API Gemini:", error);
        throw error;
    }
};